import { ReactElement } from 'react';
import { Button } from '../shared/button/Button';
import styles from './CartDrawerHeader.module.scss';
import { useAuth } from '../../contexts/AuthContext';

type Props = {
  deliveryDate: string;
  skipDeadline: string;
  buttonText: string;
  onButtonClick: () => void;
  heapId: string;
};

export function CartDrawerHeader({
  deliveryDate,
  skipDeadline,
  buttonText,
  onButtonClick,
  heapId,
}: Props): ReactElement {
  const { isLoggedIn } = useAuth();
  return (
    <div className={styles.cart_drawer_header}>
      <div className={styles.left}>
        <div className={isLoggedIn ? styles.dates : ''}>
          <div className={styles.delivery_date}>
            For Delivery
            {' '}
            {deliveryDate}
          </div>
          <div className={styles.skip_date}>
            {isLoggedIn ? (
              <>
                Edit Until
                {' '}
                {skipDeadline}
              </>
            ) : (<>These are your recommended meals: customize before subscribing</>)}
          </div>
        </div>
        {buttonText && isLoggedIn && (
          <Button
            className={styles.skip_button}
            text={buttonText}
            onClick={onButtonClick}
            isEnabled
            isSecondary
            heapId={heapId}
          />
        )}
      </div>
    </div>
  );
}
